module.exports = __webpack_public_path__ + "img/i_review_write_w.5cb45e7b.svg";